/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Prefer_Property_AgentInputs */

const cs_field_prefer_property_agent = /** @type {(inputs: Field_Prefer_Property_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferovat agenta nemovitosti`)
};

const en_field_prefer_property_agent = /** @type {(inputs: Field_Prefer_Property_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prefer property agent`)
};

/**
* | output |
* | --- |
* | "Prefer property agent" |
*
* @param {Field_Prefer_Property_AgentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_prefer_property_agent = /** @type {((inputs?: Field_Prefer_Property_AgentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Prefer_Property_AgentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_prefer_property_agent(inputs)
	return cs_field_prefer_property_agent(inputs)
});